// extracted by mini-css-extract-plugin
module.exports = {"root":"SuccessStories_root__26pMw","content":"SuccessStories_content__3oFM4","stories":"SuccessStories_stories__11YgS","heading":"SuccessStories_heading__1cYKw"};